"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HEADING_CATEGORY_KEY = 'base';
exports.HEADING_COMPONENT_KEY = 'heading';